import { Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PointsPage } from '../features/points';
import useAppStore from '../store/rootStore.ts';
import { createPageBackgroundSx } from '../styles/pageBackground.ts';

export const Route = createFileRoute('/points')({
  component: PointsRouteComponent,
  beforeLoad: () => {
    if (!useAppStore.getState().config?.features.pointsEnabled) {
      throw redirect({ to: '/trade', replace: true });
    }
  },
});

const pointsPageSx = createPageBackgroundSx();

function PointsRouteComponent() {
  return (
    <Stack sx={pointsPageSx}>
      <PointsPage />
    </Stack>
  );
}
